<template>
  <div class="login">
    <img class="background" :src="allResource.leftBgImg ? allResource.leftBgImg:require('./images/img_bgFx.png')" />
    <div class="background_title">
      <div class="first"> {{ allResource.detailInfo?allResource.detailInfo:'信誉楼百货集团有限公司版权所有' }}</div>
      <a class="first active" target="blank" style="margin-top: 5px;text-decoration: none;"
        href="https://beian.miit.gov.cn">网站ICP备案号: {{ allResource.icp?allResource.icp: '冀ICP备14017752号-1' }}</a>
      <div class="last">
        <div>{{ allResource.copyright?allResource.copyright: 'Copyright © 2019-2021 信誉楼百货集团 All Right Reserved' }}</div>
      </div>
    </div>
    <div class="login-page" :style="{ 'background-image': allResource.rightBgImg ? `url(${allResource.rightBgImg})` : '' }">
      <div>
        <div class="header">
          <img :src="allResource.storePcLoginImage?allResource.storePcLoginImage:require('./images/logo_gs.png')" alt />
        </div>
        <div class="main">
          <div class="content">
            <div class="title">Welcome Back！</div>
            <input class="input" type="text" oninput="this.value=this.value.replace(/\s+/g,'')" v-model="params.username"
              placeholder="请输入登录账号" />
            <input type="text" style="display: none" />
            <div class="show_pass">
              <input class="input" oninput="this.value=this.value.replace(/\s+/g,'')" type="text" placeholder="请输入登录密码"
                v-if="pwdType" v-model="params.pwd">
              <input class="input" oninput="this.value=this.value.replace(/\s+/g,'')" type="password"
                placeholder="请输入登录密码" v-model="params.pwd" v-else>
              <div class="show_img">
                <img :src="seen ? seenImg : unseenImg" @click="changeType()" class="eye_img" />
              </div>
            </div>
            <el-checkbox class="remember-code" v-model="checkedLogin">记住密码</el-checkbox>
            <div class="remember-forget" @click="$router.push('/forgetWord')">忘记密码</div>
            <div class="submit" @click="handleLodin">登录</div>
          </div>
        </div>
      </div>

      <!-- <div class="footer">RECYCLE</div> -->
    </div>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { encryptByDES, decryptByDES } from '@/utils/3DES'
import { mapState } from "vuex";
export default {
  name: "login",
  data() {
    return {
      allResource: {
        icp: "",//备案号
        copyright: '',//版权信息			
        detailInfo: '',//详细信息			
        domain: '',//回收商后台域名		
        leftBgImg: '',//回收商-左背景图			
        rightBgImg: '',//回收商-右背景图			
        storeBgName: '',//回收商后台名称			
        storePcLoginImage: '',//回收商后台图片			
      },
      seen: '',
      unseenImg: require('@/assets/images/login_icon_eye_close@2x.png'),//看不见
      seenImg: require('@/assets/images/login_icon_eye_@2x.png'),//看得见密码
      isLoading: false,
      pwdType: false,
      checkedLogin: true,
      params: {
        username: '',
        pwd: ''
      }
    };
  },
  created() {
    // this.havegetDomainconfig()
    if (JSON.parse(localStorage.getItem('loginUser'))) {
      this.params.username = JSON.parse(localStorage.getItem('loginUser')).username
      this.params.pwd = decryptByDES(JSON.parse(localStorage.getItem('loginUser')).pwd, '63e42c2444e94c1ebca21d30d2aa39a5')
      this.checkedLogin = JSON.parse(localStorage.getItem('loginUser')).checkedLogin
    }
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    if(this.wsClient){
      this.wsClient.close()
    }
  },
  computed: {
    ...mapState({
      wsClient: (state) => state.tagsView.wsClient,
    }),
  },
  methods: {
    //密码的显示隐藏
    changeType: function () {
      this.seen = !this.seen;//小眼睛的变化
      this.pwdType = !this.pwdType;//跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    handleLodin() {
      if (!this.params.username || !this.params.pwd) {
        return this.$message.error('请输入登录账号或密码')
      }
      const pcLoginRequest = {
        pageNum: 0,
        pageSize: 0,
        userName: this.params.username,
        password: this.params.pwd,
        token: "",
        domain: document.domain,
      };
      if (this.params.username !== "" && this.params.pwd !== "") {
        _api.postLogin(pcLoginRequest).then(res => {
          //请求返回来的数据
          console.log(res);
          //  保存token：
          if (res.code === 1) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("userImg", res.data.user.staffHeadImg);
            localStorage.setItem("userName", res.data.user.staffName);
            let user = {
              roleName: res.data.user.roleName,
              roleId: res.data.user.roleId,
              merchantName: res.data.user.merchantName,
              merchantId: res.data.user.merchantId,
              companyLogo: res.data.user.companyLogo,
              staffMobile: res.data.user.staffMobile,
              userAcc: res.data.user.userAcc,
              staffPcId: res.data.user.staffPcId,
              staffType: res.data.user.staffType,
              isOut: res.data.user.isOut,
              xcxStaffId: res.data.user.xcxStaffId,
              isSlaveAccount:res.data.user.isSlaveAccount,//是否开启从账户管理 true 开启 false 关闭
              accountType:res.data.user.accountType,//账户类型（00：主账户，01：从账户）
              examineQuoteUserId: res.data.user.examineQuoteUserId, //审单员id
              isOpenExamineQuoteWatermark: res.data.user.isOpenExamineQuoteWatermark, //审单员id
              examineQuoteUserEnable: res.data.user.examineQuoteUserEnable, //审单员是否开启审单
              staffName: res.data.user.staffName, //审单员id
              merchantShortName: res.data.user.merchantShortName, //商家简称
              examineMode: res.data.user.examineMode, //商家简称
              isOpenExamineShowQuotePrice: res.data.user.isOpenExamineShowQuotePrice,
              isOpenExamineAlterQuotePrice: res.data.user.isOpenExamineAlterQuotePrice,
            }
            localStorage.setItem("user", JSON.stringify(user));
            if (this.checkedLogin) {
              let userForm = this.params
              userForm.checkedLogin = this.checkedLogin
              userForm.pwd = encryptByDES(userForm.pwd, '63e42c2444e94c1ebca21d30d2aa39a5')
              localStorage.setItem('loginUser', JSON.stringify(userForm))
            } else {
              localStorage.removeItem('loginUser')
            }
            this.$router.push({ path: "/dashboard" });
            this.$message({
              showClose: true,
              message: "登录成功",
              type: "success"
            });
            if(res.data.user.examineQuoteUserEnable){
              if(res.data.user.examineMode === '00'){
                _api.signState().then(res => {
                  if(res.code === 1){
                    this.$store.commit("tagsView/SET_USERONLINE", res.data);
                  }
                })
              }else{
                this.$store.commit("tagsView/SET_USERONLINE", false);
              }
              
            }
          } else {
            //  登录失败
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error"
            });
          }
        });
        // } else {
        //   this.$message({
        //     showClose: true,
        //     message: "用户名和密码不能为空",
        //     type: "error"
        //   });
      }
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.handleLodin();
      }
    },
    // havegetDomainconfig() {
    //   _api.getDomainconfig({
    //     "domain": document.domain,
    //     "keys": [],
    //     "module": ""
    //   }).then(res => {
    //     console.log(res.data);
    //     if (res.code == 1) {
    //       this.allResource = res.data || {
    //         icp: "",//备案号
    //         copyright: '',//版权信息			
    //         detailInfo: '',//详细信息			
    //         domain: '',//回收商后台域名		
    //         leftBgImg: '',//回收商-左背景图			
    //         rightBgImg: '',//回收商-右背景图			
    //         storeBgName: '',//回收商后台名称			
    //         storePcLoginImage: '',//回收商后台图片			
    //       }
    //     }
    //   })
    // },
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false);
  }
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.login {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  min-height: 700px;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;

  .left {
    // width: 50%;
    // height: 100vh;
  }

  .background {
    // width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .background_title {
    position: absolute;
    bottom: 20px;
    left: 50px;
    color: white;
    text-align: left;
    z-index: 999;

    .first {
      color: #ffffff;
      width: 365px;
      font-size: 14px;
    }

    .first.active {
      cursor: pointer;
    }

    .first.active:hover {
      text-decoration: underline !important;
    }

    .last {
      margin: 5px;
      display: flex;
      height: 15px;
      font-size: 14px;
      width: 365px;
      // justify-content: space-around;
      align-items: center;
    }
  }

  .login-page {
    background: url("./images/img_bg2.png");
    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100%;
    flex: 1;
    // position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    .header {
      // position: absolute;
      right: 300px;
      top: 80px;
      display: flex;
      align-items: center;

      >img {
        width: 554px;
        height: 61px;
        margin-bottom: 40px;
      }

      >span {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #0981ff;
      }
    }

    .main {
      // position: absolute;
      width: 560px;
      height: 620px;
      background: #0981ff;
      box-shadow: 0px 5px 96px 0px rgba(78, 130, 185, 0.1),
        0px 30px 70px 0px rgba(78, 130, 185, 0.27);
      border-radius: 20px;
      padding: 8px 0 0 0;

      .content {
        width: 560px;
        height: 612px;
        background: #ffffff;
        border-radius: 20px;
        padding: 50px 50px 0px 50px;

        .title {
          font-size: 46px;
          font-family: PingFang SC;
          // font-weight: bold;
          color: #333333;
          margin-bottom: 40px;
        }

        .title2 {
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }

        .input {
          display: block;
          width: 100%;
          border: none;
          border-bottom: 1px solid #e7eaee;
          padding: 40px 0;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          outline: none;

          &::placeholder {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #b6b9d0;
            outline: none;
          }
        }

        .remember-code {
          margin: 20px 0 53px 0;
        }

        .remember-forget {
          margin: 20px 0 53px 0;
          float: right;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          text-decoration: underline;
          color: #0981FF;
          cursor: pointer;
        }

        .submit {
          width: 460px;
          height: 60px;
          background: #0981ff;
          border-radius: 10px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }

    .footer {
      position: absolute;
      left: 52px;
      bottom: 39px;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #0981ff;
    }
  }

  .show_pass {
    position: relative;

    .show_img {
      position: absolute;
      top: 40%;
      right: 5px;
      width: 25px;
      height: 25px;
    }
  }
}
</style>
